import React, { Fragment, useCallback } from 'react';
import { Paragraph } from '../Typography';
import { Container, OptionButton, OptionDivider } from './MultiToggle.styles';

import { MultiToggleProps } from './MultiToggle.types';

export const MultiToggle: React.FC<MultiToggleProps> = ({
  options,
  onChange,
  selectedOption,
  ...props
}) => {
  const isOptionSelected = useCallback(
    option => {
      return option.id === selectedOption?.id;
    },
    [selectedOption],
  );

  return (
    <Container {...props}>
      {options.map((option, i) => (
        <Fragment key={option.id}>
          <OptionButton
            data-testid={`option-${option.id}`}
            selected={isOptionSelected(option)}
            onClick={() => onChange(option)}
          >
            <Paragraph variant="p2" style={{ margin: 0 }}>
              {option.value}
            </Paragraph>
          </OptionButton>
          {i !== options.length - 1 && (
            <OptionDivider
              data-testid={`option-divider-${option.id}`}
              selected={isOptionSelected(options[i]) || isOptionSelected(options[i + 1])}
            />
          )}
        </Fragment>
      ))}
    </Container>
  );
};
